import { render, staticRenderFns } from "./normalTree.vue?vue&type=template&id=60246392&"
import script from "./normalTree.vue?vue&type=script&lang=js&"
export * from "./normalTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports